import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON } from '../../utils';
import { setCurrentSection } from '../../actions/globalConfig';
import GrantLocationTitle from '../../components/Grants/locationTitle';
import './styles.scss';

const propTypes = {
  statusText: PropTypes.string,
  sectionName: PropTypes.string,
  userName: PropTypes.string,
  profileImage: PropTypes.string
};

const defaultProps = {
  sectionName: 'grants',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png'
};

class GrantsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      grantsData: {},
    };
  }

  fetchGrants() {
    return fetch(`${SERVER_URL}/get_grants`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(function (response) {
        this.setState({'grantsData': response.data});
      }.bind(this))
      .catch((error) => {
        console.log(error, 'An error occurred');
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  componentWillMount() {
    this.fetchGrants();
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  generateHtml () {
    return {__html: this.state.grantsData.intro};
  }

  render() {
    const {grants} = this.state.grantsData;
    if (!grants) {
      return null;
    }

    return (
        <div className="container-fluid content grants-page bg-fff-65">
          <div className="row">
            <div className="col-sm-12 pr-35 pl-35">
              <div className="text-justify" dangerouslySetInnerHTML={this.generateHtml()} />

              <div>
                {grants.map(function(regions, index){

                  return (

                    <div key={index} className="grants-info">
                      {Object.keys(regions).map(function(regionName){
                        return (
                          <div key={regionName}>
                            <h1>{regionName}</h1>

                            <GrantLocationTitle regions={regions[regionName]} />
                          </div>
                        );

                      })}
                    </div>

                  );

                })}
              </div>
            </div>
          </div>
        </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath
  };
};

GrantsView.propTypes = propTypes;
GrantsView.defaultProps = defaultProps;

export default connect(mapStateToProps)(GrantsView);
